import { GlAvatar, GlSprintf, GlLink, GlSkeletonLoader } from '@gitlab/ui';
import { isEqual } from 'lodash-es';
import PageHeading from '~/vue_shared/components/page_heading.vue';
import { AVATAR_SHAPE_OPTION_RECT } from '~/vue_shared/constants';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'TitleArea',
    components: {
        GlAvatar,
        GlSprintf,
        GlLink,
        GlSkeletonLoader,
        PageHeading
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        avatar: {
            type: String,
            default: null,
            required: false
        },
        title: {
            type: String,
            default: null,
            required: false
        },
        infoMessages: {
            type: Array,
            default: ()=>[],
            required: false
        },
        inlineActions: {
            type: Boolean,
            default: true,
            required: false
        },
        metadataLoading: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            metadataSlots: []
        };
    },
    created () {
        this.recalculateMetadataSlots();
    },
    updated () {
        this.recalculateMetadataSlots();
    },
    methods: {
        recalculateMetadataSlots () {
            const METADATA_PREFIX = 'metadata-';
            const metadataSlots = Object.keys(this.glSlots()).filter((k)=>k.startsWith(METADATA_PREFIX));
            if (!isEqual(metadataSlots, this.metadataSlots)) {
                this.metadataSlots = metadataSlots;
            }
        }
    },
    AVATAR_SHAPE_OPTION_RECT
};
